/* If browser back button was used, flush cache */
// (function () {
// 	window.onpageshow = function(event) {
// 		var historyTraversal = event.persisted,
// 			perf = window.performance,
// 			perfEntries =
// 				perf && perf.getEntriesByType && perf.getEntriesByType("navigation"),
// 			perfEntryType = perfEntries && perfEntries[0] && perfEntries[0].type,
// 			navigationType = perf && perf.navigation && perf.navigation.type;
// 		if (
// 			historyTraversal ||
// 			perfEntryType === "back_forward" ||
// 			navigationType === 2
// 		) {
// 			alert('Back button clicked');
// 		}
// 	};
// })();
(function () {
	var body = $('body');

	if (body.is('.page-template-insights_page-php, .page-template-mobidev_life_page-php')) {
		const urlParams = window.location.href.split('/');
		if ((urlParams[3] === 'trends-and-insights' || urlParams[3] === 'mobidev-life') && !urlParams[4]) {
			if (localStorage.getItem('slide_index') !== null) {
				localStorage.setItem('slide_index', '0');
			}
		}
	}
	var filterFns = {
		numberGreaterThan50: function () {
			var number = $(this).find('.number').text();
			return parseInt(number, 10) > 50
		}, ium: function () {
			var name = $(this).find('.name').text();
			return name.match(/ium$/)
		}
	};
	if (localStorage.getItem('filter_value') !== null && !body.is('.page-template-case_page-php, .single-case')) {
		localStorage.removeItem('filter_value')
	}
	if (body.is('.single-flexible, .single-insights, .single-articles, .page-template-insights_page-php, .page-template-mobidev_life_page-php')) {
		var swiperContainer = $('.swiper-container');
		var swiperWrapper = $('.swiper-wrapper');
		var swiperSlide = $('.swiper-slide');
		var termsCount = swiperWrapper.data('count-terms');
		$('.additional-menu ul li a').click(function (e) {
			var li = $(this).parent();
			localStorage.setItem('slide_index', li.attr('data-slider-index'));
		});
		if (swiperContainer[0]) {
			let mySwiper;

			const enableSwiper = function() {
				mySwiper = new Swiper('.swiper-container', {
					slidesPerView: termsCount < 3 ? termsCount : 3,
					spaceBetween: termsCount < 3 ? 0 : 30,
					loop: true,
					centeredSlides: true,
					pagination: {
						el: ".swiper-pagination",
						clickable: true
					},
					breakpoints: {320: {spaceBetween: 0}}
				});
				swiperWrapper.css('display', 'flex');
			}
			var onSwiperReady = window.mobidevOnSwiperReady || function (cb) {
				if (typeof Swiper !== 'undefined') {
					cb();
				}
			};
			onSwiperReady(enableSwiper);

			// const mySwiper = new Swiper('.swiper-container', {
			// 	slidesPerView: termsCount < 3 ? termsCount : 3,
			// 	spaceBetween: termsCount < 3 ? 0 : 30,
			// 	loop: true,
			// 	centeredSlides: true,
			// 	pagination: {
			// 		el: ".swiper-pagination",
			// 		clickable: true
			// 	},
			// 	breakpoints: {320: {spaceBetween: 0}}
			// });
			// swiperWrapper.css('display', 'flex');

			window.addEventListener( "pageshow", function ( event ) {
				var historyTraversal = event.persisted,
					perf = window.performance,
					perfEntries =
						perf && perf.getEntriesByType && perf.getEntriesByType("navigation"),
					perfEntryType = perfEntries && perfEntries[0] && perfEntries[0].type,
					navigationType = perf && perf.navigation && perf.navigation.type;
				if (
					historyTraversal ||
					perfEntryType === "back_forward" ||
					navigationType === 2
				) {
					// alert("Browser back button is clicked.");

					var url = $(location).attr('href'),
						parts = url.split("/"),
						last_part = parts[parts.length - 1];

					if (last_part) {
						let slideTo = parseInt($(".swiper-slide[data-hash='" + last_part + "']").not('.swiper-slide-duplicate').attr("data-swiper-slide-index"));
						mySwiper.destroy();
						enableSwiper();

						mySwiper.slideToLoop(slideTo, 100, false);
						localStorage.setItem('slide_index', mySwiper.realIndex);
					}
				}
			});

			if (localStorage.getItem('slide_index') !== null) {
				mySwiper.slideToLoop(parseInt(localStorage.getItem('slide_index')), 100, false);
			}
			mySwiper.on('slideChangeTransitionEnd', function () {
				const currentSlide = mySwiper.realIndex;
				localStorage.setItem('slide_index', currentSlide);
				window.location.href = $('.swiper-slide-active').find('a').attr('href');
			});
			swiperSlide.on('mousedown touchstart', function (e) {
				var currentSlide = $(this).data('swiper-slide-index');
				localStorage.setItem('slide_index', currentSlide);
			});
			$('.swiper-slide a').on('click', function (e) {
				e.preventDefault();
				var link = $(this).attr('href')
				var currentSlide = $(this).parent().data('swiper-slide-index');

				mySwiper.slideToLoop(currentSlide, 600, !1);
				localStorage.setItem('slide_index', mySwiper.realIndex);
				setTimeout(function () {
					window.location.href = link
				}, 1000);
				// window.location.href = $(this).attr('href');
			});
			// $('.swiper-slide a').on('click mousedown touchstart', function (e) {
			// 	e.preventDefault();
			//
			// 	console.log($(this))
			// });
		}
	} else {
		if (localStorage.getItem('slide_index') !== null) {
			localStorage.setItem('slide_index', '0');
		}
	}
	var filter = $('.page-template-case_page-php .filters-button-group');
	filter.on('click', 'a', function () {
		var filterValue = $(this).attr('data-filter');
		localStorage.setItem('filter_value', filterValue);
		filterValue = filterFns[filterValue] || filterValue;
		$grid.isotope({filter: filterValue});
		return !1
	});
	filter.each(function (i, buttonGroup) {
		var $buttonGroup = $(buttonGroup);
		$buttonGroup.on('click', 'a', function () {
			$buttonGroup.find('.is-checked').removeClass('is-checked');
			$(this).addClass('is-checked');
			$('.additional-menu .active-text').text($(this).text())
		})
	});
	if (localStorage.getItem('filter_value') !== null && body.is('.page-template-case_page-php')) {
		var filterValue = localStorage.getItem('filter_value');
		filter.each(function (i, buttonGroup) {
			var $buttonGroup = $(buttonGroup);
			$buttonGroup.children('li').find('.is-checked').removeClass('is-checked');
			$(this).find(`[data-filter='${filterValue}']`).addClass('is-checked');
			$('.additional-menu .active-text').text($(this).children('li').find('a.is-checked').text())
		});
		filterValue = filterFns[filterValue] || filterValue;
		$grid.isotope({filter: filterValue});
		return !1
	}
})();
